export default "__VITE_ASSET__Dvp30AE2__"